import { DataService } from './dataService'


export const CategoryService ={
    getCategory: async (data) => {
        return DataService.get('/admin/category/list', data)
    },
    editCategory: async (data) => {
        return DataService.put('/admin/category/update', data)
    },
    getSingalCategory: async (data) => {
        return DataService.get('/admin/category/list', data)
    },
	addCategory: async (data) => {
        return DataService.post('/admin/category/create', data)
    },
	deleteCategory: async (data) => {
        return DataService.delete('/admin/category/delete', data)
    },
    asignSubcategort: async (data) => {
        return DataService.post('/admin/subcategory/assign', data)
    },
    
}